module.exports = __webpack_public_path__ + "static/media/favicon.d9de4b50.png";